module.exports = __webpack_public_path__ + "img/1570650974.b9527ffa.jpg";